var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinStack = function SvgCoinStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#D09D06",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#coin-stack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.184 12.796c3.956 0 7.163-1.425 7.163-3.184 0-1.758-3.207-3.183-7.163-3.183S8.02 7.854 8.02 9.612c0 1.759 3.207 3.184 7.163 3.184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02 9.612v9.551c0 1.751 3.184 3.184 7.164 3.184s7.163-1.433 7.163-3.184v-9.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.347 14.388c0 1.75-3.184 3.183-7.163 3.183S8.02 16.14 8.02 14.388M15.025 3.259a10.78 10.78 0 0 0-6.208-1.592c-3.964 0-7.164 1.433-7.164 3.184 0 .939.924 1.783 2.388 2.387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.041 16.79c-1.464-.605-2.388-1.449-2.388-2.388V4.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.041 12.014c-1.464-.605-2.388-1.448-2.388-2.388"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coin-stack_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgCoinStack as ReactComponent };
export default __webpack_public_path__ + "4b3881ab445769e16137ffc670bb757f.svg";